var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.96C27.9411 36.96 36 28.9011 36 18.96C36 9.01884 27.9411 0.959961 18 0.959961C8.05887 0.959961 0 9.01884 0 18.96C0 28.9011 8.05887 36.96 18 36.96Z",
    fill: "#E21B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2916 10.4586L9.50781 13.2441L23.7107 27.4563L26.4945 24.6708L12.2916 10.4586Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7107 10.4577L9.50781 24.6699L12.2916 27.4555L26.4945 13.2433L23.7107 10.4577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.ae9b890df20b3341b7e94ba4de414535.svg";
export { ForwardRef as ReactComponent };